import { render, staticRenderFns } from "./cabecalho.vue?vue&type=template&id=c68cf08e&"
import script from "./cabecalho.vue?vue&type=script&lang=js&"
export * from "./cabecalho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports